import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Hls from "hls.js";
import "../styles/AdScreen.css";

const AdScreen = () => {
  const navigate = useNavigate();
  const [skippable, setSkippable] = useState(false);
  const [loading, setLoading] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    const hlsUrl = process.env.PUBLIC_URL + "/ad/Tabata Showreel.m3u8";

    let hls;

    if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(hlsUrl);
      hls.attachMedia(video);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        setLoading(false);
        video.play().catch(err => console.error("Chyba při přehrávání:", err));
      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("HLS error:", data);
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = hlsUrl;
      video.addEventListener("loadedmetadata", () => {
        setLoading(false);
        video.play().catch(err => console.error("Chyba při přehrávání:", err));
      });
    } else {
      console.error("HLS není podporováno tímto prohlížečem.");
      setLoading(false);
    }

    const timer = setTimeout(() => setSkippable(true), 5000);

    return () => {
      clearTimeout(timer);
      if (hls) hls.destroy();
    };
  }, []);

  const handleSkip = () => {
    navigate("/timer");
  };

  const handleVideoClick = () => {
    window.open("https://www.tabataworkout.online", "_blank");
  };

  return (
    <div className="ad-screen-container">
      {loading && <div className="loader">Načítání reklamy...</div>}

      <video
        ref={videoRef}
        width="100%"
        controls
        playsInline
        className="ad-video"
        onEnded={handleSkip}
        onClick={handleVideoClick}
        style={{ cursor: "pointer", display: loading ? "none" : "block" }}
      >
        Váš prohlížeč nepodporuje video tag.
      </video>

      {skippable && (
        <button onClick={handleSkip} className="skip-button">
          Skip Ad
        </button>
      )}

      {/* Watermark v rohu stránky */}
     <div className="page-corner-watermark">©</div>

    </div>
  );
};

export default AdScreen;
